import { defineMessages } from 'react-intl';

export default defineMessages({
    myclaims: {
        id: 'header.Business Home',
        defaultMessage: 'My claims'
    },
    myProfile: {
        id: 'header.My Profile',
        defaultMessage: 'My profile'
    },
    logout: {
        id: 'header.logout',
        defaultMessage: 'Logout'
    },
    onlineServices: {
        id: 'header.Online Services',
        defaultMessage: 'Online services'
    },
    french: {
        id: 'header.French',
        defaultMessage: 'Français'
    },
    menu: {
        id: 'header.modal.Menu',
        defaultMessage: 'Menu'
    },
    iAm: {
        id: 'header.I am Label',
        defaultMessage: 'I am: '
    },
    aBusiness: {
        id: 'header.iAmDropdown.input.Business',
        defaultMessage: 'a business'
    },
    wsibLogoTitle: {
        id: 'header.wsibLogoTitle',
        defaultMessage: 'Home. Opens in a new tab.'
    },
    injuredOrIll: {
        id: 'header.iAmDropdown.input.Injured or Ill',
        defaultMessage: 'Injured or Ill'
    },
    username: {
        id: 'header.username',
        defaultMessage: 'hello, '
    },
    exit: {
        id: 'header.exit',
        defaultMessage: 'Exit'
    },
    claimInformation: {
        id: 'header.claimInfo',
        defaultMessage: 'Claim information',
    },
    documents: {
        id: 'header.documents',
        defaultMessage: 'Claim-related documents',
    },
    messages: {
        id: 'header.messages',
        defaultMessage: 'Messages',
    },
    resources: {
        id: 'header.resources',
        defaultMessage: 'Resources',
    },
    claimOverview: {
        id: 'header.claimOverview',
        defaultMessage: 'Claim overview',
    },
    benefitPayment: {
        id: 'header.benefitPayment',
        defaultMessage: 'Benefit payments',
    },
    healthCareBenefits: {
        id: 'header.healthCareBenefits',
        defaultMessage: 'Health care benefits',
    },
    nonHealthCareBenefits: {
        id: 'header.nonHealthCareBenefits',
        defaultMessage: 'Non-Health care benefits',
    },
    appeals: {
        id: 'header.appeals',
        defaultMessage: 'Appeals',
    },
    claimDocuments: {
        id: 'header.claimDocuments',
        defaultMessage: 'Submit documents',
    },
    documentHistory: {
        id: 'header.documentHistory',
        defaultMessage: 'View submitted documents',
    },
    claimRelated: {
        id: 'header.claimRelated',
        defaultMessage: 'View claim-related documents',
    },
    claimDocumentsAriaLabel: {
        id: 'header.claimDocumentsAriaLabel',
        defaultMessage: 'Submit claim-related documents',
    },
    documentHistoryAriaLabel: {
        id: 'header.documentHistoryAriaLabel',
        defaultMessage: 'View submitted claim-related documents',
    },
    claimRelatedAriaLabel: {
        id: 'header.claimRelatedAriaLabel',
        defaultMessage: 'View documents related to your claim',
    },
    sendUsMessage: {
        id: 'header.sendUsMessage',
        defaultMessage: 'Send us a message',
    },
    mail: {
        id: 'header.mail',
        defaultMessage: 'Mail',
    },
    helpfulLink: {
        id: 'header.helpfulLink',
        defaultMessage: 'Helpful links',
    },
    faq: {
        id: 'header.faq',
        defaultMessage: 'Frequently asked questions',
    },
    YouSure: {
        id: 'claim-intake.header.YouSure',
        defaultMessage: 'Are you sure you want to leave this page?',
    },
    YouSureNoRef: {
        id: 'claim-intake.header.YouSureNoRef',
        defaultMessage: 'Are you sure?',
    },
    ChangeReportType: {
        id: 'claim-intake.header.ChangeReportType',
        defaultMessage: 'All your progress will be lost.',
    },
    ChangeReportingNoRef: {
        id: 'claim-intake.header.ChangeReportingNoRef',
        defaultMessage: 'Are you sure you want to exit? Your report will be deleted.',
    },
    Cancel: {
        id: 'claim-intake.header.Cancel',
        defaultMessage: 'Stay on this page',
    },
    CancelNoRef: {
        id: 'claim-intake.header.NoRef',
        defaultMessage: 'No',
    },
    Confirm: {
        id: 'claim-intake.header.Confirm',
        defaultMessage: 'Leave this page',
    },
    ConfirmNoRef: {
        id: 'claim-intake.header.ConfirmNoRef',
        defaultMessage: 'Yes',
    },
    YouSureChangeLanguage: {
        id: 'claim-intake.header.YouSureChangeLanguage',
        defaultMessage: 'Are you sure?',
    },
    ChangeLanguage: {
        id: 'claim-intake.header.ChangeLanguage',
        defaultMessage: 'Are you sure you want to change the language? All your progress will be lost.'
    },
    OSBCdisruptionText: {
        id: 'header.OSBCdisruptionText',
        defaultMessage: 'Following the labour disruption, we’re working hard to get back to our usual service timelines. If you are in crisis and need support, call 911 or you can call the Crisis Helpline at 988.',
    },
    notificationAriaLabel: {
        id: 'claim-intake.header.notificationAriaLabel',
        defaultMessage: 'new notifications',
    },
    PIQUpdateHeading: {
        id: 'piq-unlock-modal-heading',
        defaultMessage: 'Action required'
    },
    piqUpdateInofrmation: {
        id: 'piq-unlock-modal-information',
        defaultMessage: 'Please update your personal identification questions and answers to use our online services.'
    },
    updateInformation: {
        id: 'piq-update-information-button',
        defaultMessage: 'Update information'
    },
    logoutButton: {
        id: 'piq-logout-button',
        defaultMessage: 'Log out'
    },
    modalTitle: {
        id: 'iAmDropdownModal.modalTitle',
        defaultMessage: 'Switch to businesses?'
    },
    modalDesp: {
        id: 'iAmDropdownModal.modalDesp',
        defaultMessage: 'You’re leaving online services for injured or ill people and going to online services for businesses. You’ll need to provide a contact phone number to continue.'
    },
    continueButton: {
        id: 'iAmDropdownModal.continueButton',
        defaultMessage: 'Continue to online services for businesses'
    },
    cancelButton: {
        id: 'iAmDropdownModal.cancelButton',
        defaultMessage: 'Cancel'
    },
});
